///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportMerchantAccount = Meevo.Plugins.Reports.IReportMerchantAccount;


    export class ReportMerchantAccountCollection extends SmartMoverApiCollection<IReportMerchantAccount> implements IApiCollection<IReportMerchantAccount> {

        get url() {
            return 'merchantAccount';
        }
    }

}
